/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/

import { CoreCustomPageType } from '@workflow/class/workflow.type';
import { CustomPageBase } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';

export type CustomPageType =
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  CoreCustomPageType | 'legacy-review' | 'slideout';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function CustomPage(controlType: CustomPageType): (target) => void {
  return (target) => CustomPageBase<CustomPageType>(controlType, target);
}
